import { useEffect } from "react";
import "./about.css"; // or .scss
import { FaArrowRight } from "react-icons/fa";

// Team Data Array updated with the new content
const teamMembers = [
  {
    id: 1,
    name: "Milind Babar",
    role: "Founder & Managing Director",
    company: "Mango Holidays India Pvt. Ltd.",
    bio: "Milind Babar began his career in tourism when it was still in its infancy. With 32 years of experience, he has witnessed the sector's evolution in India from its early stages to the global market that it is today. Having traveled extensively and engaged with a diverse range of international travelers, he developed a deep understanding of unique client needs and preferences. This expertise led him to establish Mango Holidays, where his primary focus is leveraging these insights to design tour programs that deliver exceptional travel experiences. He remains committed to Values over Volumes, Quality over Quantity. Ethical and Transparent Interactions, driving business development and cultivating strong, result-oriented relationships with valued partners and suppliers.",
    image: "/img/milind-babar.jpeg", // Replace with actual image path
  },
  {
    id: 2,
    name: "Tapasya Dharap",
    role: "Director – Operations",
    company: "Mango Holidays India Pvt. Ltd.",
    bio: "Tapasya Dharap has been managing Mango Holidays Mumbai office with youthful dynamism and fine professional skills. A post graduate in business administration, Tapasya is a meticulous planner. Along with her trusted team, she oversees the efficient running of Mumbai Branch and impeccable delivery of our services. As Director – Operations, she handles various aspects of the tours: airlines, hotels, coaches, restaurants, sightseeing and tour managers. She is also in charge of forming itineraries, introducing new features and ensuring that Mango Holidays’ tours are of the best quality.",
    image: "/img/tapasya-dharap.jpeg", // Replace with actual image path
  },
  {
    id: 3,
    name: "Ranjana Babar",
    role: "Director - Sales",
    company: "Mango Holidays India Pvt. Ltd.",
    bio: "Ranjana Babar is a highly energetic and self motivated personality. She heads the Admin team and is also responsible for training and development of the team. Her pleasant individuality and exceptional people management skills make her the perfect fit to spearhead team development at Mango Holidays. She has a strong passion for tourism, she has travelled extensively and that has given her hands-on knowledge of the business. Her enthusiasm and positive attitude keeps the entire team inspired. Her able guidance has been instrumental in making Mango Holidays such a well established name in the tourism industry today.",
    image: "/img/ranjana-babar.jpeg", // Replace with actual image path
  },
];

const About = () => {
  useEffect(() => {
    document.title = "About | Mango Holidays";
  }, []);

  return (
    <>
      {/* -- Banner Section -- */}
      <section className="banner-section-about">
        <div className="img-container-about">
          <img src="/img/about-us-banner.webp" alt="Banner" />
        </div>
        <div className="banner-overlay-about" />
      </section>

      {/* -- About Section -- */}
      <section className="about-container">
        {/* -- Left Section -- */}
        <div className="about-left">
          <div className="about-left-inner">
            <img
              src="/img/global-experience-local-comfort.webp"
              alt="Mango Holidays Logo"
              className="about-logo"
            />

            <h2>Experience Unforgettable Journeys with</h2>
            <h1>Mango Holidays</h1>
            <h3>Your Trusted Travel Partner Since 2008</h3>

            <h2>About</h2>
            <p>
              At Mango Holidays, we are dedicated to crafting unforgettable
              travel experiences for our guests. Since our inception on January
              1st, 2008, we have grown exponentially, establishing offices in
              key locations across Mumbai, Pune, Thane, and Nagpur. Our
              commitment to excellence and customer satisfaction has propelled
              us to become a trusted name in the travel industry.
            </p>
          </div>
        </div>

        {/* -- Right Section -- */}
        <div className="about-right">
          <div className="mission-section">
            <h1>
              Our <span className="orange-text">Mission</span>
            </h1>
            <p>
              Our mission at Mango Holidays is simple yet profound: to create
              experiences of a lifetime for our guests. We believe in going
              beyond the ordinary to ensure that every journey with us is filled
              with moments of joy, discovery, and adventure. From group tours to
              customized packages, and corporate events to visa assistance, we
              provide comprehensive travel solutions tailored to meet your
              needs.
            </p>
          </div>

          <div className="mission-section">
            <h1>
              Core <span>Values</span>
            </h1>

            <p>
              At the heart of Mango Holidays are our core values, which guide
              everything we do:
            </p>

            <p>
              <FaArrowRight className="icon" />
              <strong>Customer First: </strong>
              Our guests are at the center of everything we do, and their
              satisfaction is our top priority.
            </p>

            <p>
              <FaArrowRight className="icon" />
              <strong>Teamwork: </strong>
              We believe in the power of collaboration and teamwork to deliver
              exceptional results.
            </p>

            <p>
              <FaArrowRight className="icon" />
              <strong>Ownership: </strong>
              Each member of our team takes ownership of their responsibilities,
              ensuring accountability and excellence in every aspect of our
              service.
            </p>

            <p>
              <FaArrowRight className="icon" />
              <strong>Honest & Ethical Interactions: </strong>
              Transparency and integrity are fundamental to our interactions,
              ensuring trust and confidence in our relationships.
            </p>

            <p>
              <FaArrowRight className="icon" />
              <strong>Pursuit of Excellence: </strong>
              We are committed to continuous improvement and excellence in all
              that we do, striving to exceed expectations at every opportunity.
            </p>
          </div>

          <div className="mission-section">
            <h1>
              Our <span>Purpose</span>
            </h1>
            <p>
              At Mango Holidays, our purpose goes beyond just providing travel
              services. We aim to enrich lives and increase the happiness
              quotient of our society by making every travel experience truly
              exceptional.
            </p>
          </div>
        </div>
      </section>

      {/* -- Why Choose Us Section -- */}
      <section className="why-choose-us-section">
        <div className="container">
          <h2 className="section-title">Why Choose Us?</h2>

          <div className="choose-us-grid">
            <div className="choose-us-card">
              <div className="icon-container">
                <img src="/img/values.webp" alt="Values Over Volumes" />
              </div>
              <div className="card-text">
                <h2>Values Over Volumes</h2>
                <p>
                  Unlike mass tour operators, we organize a select number of
                  exclusive tours to each destination annually, allowing us to
                  focus on quality and personalized experiences.
                </p>
              </div>
            </div>

            <div className="choose-us-card">
              <div className="icon-container">
                <img src="/img/quality.webp" alt="Quality Over Quantity" />
              </div>
              <div className="card-text">
                <h2>Quality Over Quantity</h2>
                <p>
                  We prioritize quality in every aspect of our service, from
                  selecting the finest airlines and accommodations to providing
                  premium transportation and tour experiences.
                </p>
              </div>
            </div>

            <div className="choose-us-card">
              <div className="icon-container">
                <img src="/img/team.webp" alt="Qualified Team" />
              </div>
              <div className="card-text">
                <h2>Qualified Team</h2>
                <p>
                  Our team comprises passionate and experienced individuals who
                  are dedicated to making your holidays memorable.
                </p>
              </div>
            </div>

            <div className="choose-us-card">
              <div className="icon-container">
                <img
                  src="/img/honesty.webp"
                  alt="Honest & Ethical Interactions"
                />
              </div>
              <div className="card-text">
                <h2>Honest & Ethical Interactions</h2>
                <p>
                  With Mango Holidays, you can trust that you’ll receive
                  transparent and honest dealings, with no hidden costs or
                  surprises along the way.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* -- Our Team Section -- */}
      <section className="our-team-section">
        <div className="container">
          <h2 className="section-title">Our Team</h2>
          <div className="team-wrapper">
            {teamMembers.map((member) => (
              <div className="team-row" key={member.id}>
                {/* Image Side */}
                <div className="team-image-col">
                  <div className="image-frame">
                    <img src={member.image} alt={member.name} />
                    {/* Decorative colored box behind the image */}
                    <div className="decor-box"></div>
                  </div>
                </div>

                {/* Content Side */}
                <div className="team-content-col">
                  <h3 className="member-name">{member.name}</h3>
                  <p className="member-role">
                    {member.role} <br />
                    <span>{member.company}</span>
                  </p>
                  <p className="member-bio">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
